import React from 'react';

const STEPS = [
  'Motivo',
  'Procesos activos',
  'Plan de transición',
  'Confirmación',
  'Reunión de salida',
];

interface Props {
  currentStep: number;
}

export const StepperHeader: React.FC<Props> = ({ currentStep }) => {
  return (
    <div className="flex items-center justify-center gap-1.5 sm:gap-2 overflow-x-auto pb-1">
      {STEPS.map((label, idx) => {
        const step = idx + 1;
        const done = step < currentStep;
        const active = step === currentStep;
        return (
          <React.Fragment key={label}>
            <div className="flex items-center gap-1.5 shrink-0">
              <span
                className={[
                  'flex h-6 w-6 sm:h-7 sm:w-7 items-center justify-center rounded-full text-xs font-semibold border shrink-0',
                  done
                    ? 'bg-primary border-primary text-primary-foreground'
                    : active
                      ? 'border-primary text-primary bg-white'
                      : 'border-gray-300 text-gray-400 bg-white',
                ].join(' ')}
              >
                {done ? '✓' : step}
              </span>
              <span
                className={[
                  'text-[11px] sm:text-xs whitespace-nowrap',
                  active ? 'text-gray-900 font-semibold' : done ? 'text-gray-700' : 'text-gray-400',
                ].join(' ')}
              >
                {label}
              </span>
            </div>
            {step < STEPS.length && (
              <span className="h-px w-2.5 sm:w-5 bg-gray-200 shrink-0" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepperHeader;
